import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { AuthProvider } from '@/auth/AuthProvider'
import { NotifyProvider } from '@/components/Notify'
import { router } from '@/router'

// QueryClient создаётся один раз на модуль — `advanced-init-once`.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NotifyProvider>
          <RouterProvider router={router} />
        </NotifyProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
